// Generates a UUID v4 session token for the Google Places Autocomplete (New) + Address
// Validation flow (see GoogleAddressTypeahead.vue and App\Http\Requests\Address\International\
// SuggestInternationalAddressRequest::SESSION_TOKEN_PATTERN, which validates this exact shape
// server-side). Google's own guidance: generate one token per session, use the SAME token for
// every Autocomplete call and the terminating Address Validation call, then generate a fresh one
// - never reuse a token after a session has concluded (a successful validate, an explicit
// confirm/reject decision, or the component being destroyed/abandoned).
//
// Pure and dependency-free so it is independently unit-testable, matching this codebase's other
// helpers (addressCountry.js, addressEnrichmentAutofill.js).
export function generateSessionToken() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  var bytes;
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
  } else {
    bytes = new Uint8Array(16);
    for (var i = 0; i < 16; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  // RFC 4122 version 4: set version (4) and variant (10xx) bits.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  var hex = [];
  for (var j = 0; j < 256; j++) {
    hex[j] = (j < 16 ? '0' : '') + j.toString(16);
  }

  var b = bytes;
  return (
    hex[b[0]] + hex[b[1]] + hex[b[2]] + hex[b[3]] + '-' +
    hex[b[4]] + hex[b[5]] + '-' +
    hex[b[6]] + hex[b[7]] + '-' +
    hex[b[8]] + hex[b[9]] + '-' +
    hex[b[10]] + hex[b[11]] + hex[b[12]] + hex[b[13]] + hex[b[14]] + hex[b[15]]
  );
}

export default generateSessionToken;
